import { API_URL } from "../../config/connect";

async function getReviewsAd({ id }) {
    try {
        const response = await fetch(`${API_URL}/api/v1/reviews/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching reviews: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in getReviews:", error);
        return [];
    }
}

export { getReviewsAd };